interface HeadersOptions {
  xsrf: string;
  authorization?: string;
}

export const getHeadersOptions = (): HeadersOptions => {
  const baseOptions = {
    xsrf: window.ADV.settings.tokens.xsrf,
  };

  if (window.ADV.settings.tokens.access_token) {
    return {
      ...baseOptions,
      authorization: `Bearer ${window.ADV.settings.tokens.access_token}`,
    };
  }
  return baseOptions;
};
